import { Boolean, Number, Partial, Static, String } from "runtypes";

export const UserRunType = Partial({
  email: String,
  id: Number,
  isAdmin: Boolean,
  isDirector: Boolean,
  isVerify:Boolean,
  videoCount:Number,
  status:Boolean,
  firstName:String,
  lastName:String
});
export const UserEmailType = Partial({
  email: String,
});

export interface IUser extends Static<typeof UserRunType> {
  restrictedCoaches?: number[] | null;

}


// WEBPACK FOOTER //
// ./src/services/IUser.ts